import { Link as LinkRouter } from 'react-router-dom';
import { Link } from '@ontruck/orc';

const OrderLink = ({ id }) => <IdLink id={id} destination="queued" text={`S${id}`} />;
const TasksLink = ({ id }) => <IdLink id={id} destination="tasks" text={`J${id}`} />;

const CarrierLink = ({ id, text }) => {
  if (!id) {
    return text;
  }
  return <IdLink id={id} destination="carrier" text={text} />;
};

const DriverLink = ({ carrier_id, driver_id, text }) => {
  if (!carrier_id || !driver_id) {
    return text;
  }

  return <IdLink id={driver_id} destination={`carrier/${carrier_id}/driver`} text={text} />;
};

const IdLink = ({ id, destination, text }) => (
  <Link
    as={LinkRouter}
    text={text ? text : `${id}`}
    to={`/${destination}/${id}`}
    key={id}
    style={{ marginRight: '4px' }}
    data-testid={`link-${id}`}
  />
);

export { IdLink, OrderLink, TasksLink, CarrierLink, DriverLink };
